import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { ImageEditorTab } from '@/features/editor/widgets/custom-widget/inputs/background/image/shared/models';
import { extractBlobFromBackgroundUrl } from '@/features/editor/widgets/custom-widget/inputs/shared/utils';

export const ImageEditorContext = React.createContext(
  {} as ImageEditorContextProps,
);

export function newImageEditorContext(
  origImage: string,
  aspectRatio?: number | undefined,
): ImageEditorContextProps {
  const [mode, setMode] = useState(ImageEditorTab.ADD_IMAGE);
  const blobToCompress = useRef<Blob>();
  const [shouldCompress, setShouldCompress] = useState(false);
  const [image, setImage] = useState<string | undefined>(
    origImage === `` || isPlaceholder(origImage)
      ? undefined
      : extractBlobFromBackgroundUrl(origImage),
  );
  const [isGif, setIsGif] = useState(false);
  const gifFileRef = useRef<File | null>(null);

  useEffect(() => {
    if (image && !isPlaceholder(image)) {
      // Skip editor for GIFs
      if (!isGif) {
        setMode(ImageEditorTab.EDIT);
      }
    }

    if (!image && mode === ImageEditorTab.EDIT) {
      setMode(ImageEditorTab.ADD_IMAGE);
    }
  }, [image, isGif]);

  return {
    blobToCompress,
    shouldCompress,
    setShouldCompress,
    mode,
    setMode,
    image,
    setImage,
    aspectRatio,
    isGif,
    setIsGif,
    gifFileRef,
  };
}

export interface ImageEditorContextProps {
  blobToCompress: MutableRefObject<Blob>;
  shouldCompress: boolean;
  setShouldCompress: (b: boolean) => void;
  mode: ImageEditorTab;
  setMode: (tab: ImageEditorTab) => void;
  image: string | undefined;
  setImage: (image: string) => void;
  aspectRatio: number | undefined;
  isGif: boolean;
  setIsGif: (isGif: boolean) => void;
  gifFileRef: MutableRefObject<File | null>;
}

export function isPlaceholder(origImage: string) {
  return (
    origImage.endsWith(`placeholder.svg)`) ||
    origImage.endsWith(`placeholder.svg`) ||
    origImage.endsWith(`placeholder.jpeg)`) ||
    origImage.endsWith(`placeholder.jpeg`)
  );
}
